
import Vue from 'vue'
import Router from 'vue-router'
import Panel from '../view/Panel/index.vue'
import banshu from './model/banshu'
import Login from '../view/Login/index.vue'
import housework from './model/housework'
import share from './model/share'
import BoardShareDetail from '../view/share/BoardShareDetail'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path:'/findpassword',
      name:'FindPassword',
      component:()=> import('../view/Login/FindPassword.vue')
    },{
      path:'/register',
      name:'Register',
      component:()=> import('../view/Login/Register.vue')
    },{
      path:'/provice/:name',
      name:'Provice',
      component:() => import('../view/Login/Provice.vue')
    },
    {
      path: '/Panel',
      name: 'Panel',
      component: Panel,
      redirect: '/banshu',
      children: [
        ...banshu,// 路由合并方法
        ...housework
      ]
    },
    {
      path: '/moreVersion',
      name: 'MoreVersion',
      component: ()=> import('../view/Login/MoreVersion.vue')
    },
    ...share
  ]
})
// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // 路由导航守卫
  // to 代表将要访问的路径
  // from 代表从哪个路径跳转而来
  // next 是一个函数，表示放行
  // 1.next()  放行    2.next('/login')  强制放行

  // 获取token
  const tokenStr = window.sessionStorage.getItem('token') // 获取token
  if (!tokenStr) {
    if (to.path === '/' || to.path === '/single' || to.path.includes('/boardShare') || to.path.includes('provice') || to.path.includes('/boardShareDetail') || to.path === '/register' || to.path === '/findpassword' || to.path === '/moreVersion') {
      next()
    }
  } else {
    if (to.path === '/') {
      window.history.go(-1)
    } else {
      next(false)
    }
    next()
  }

  // if (to.path === '/') return next()
  // // if (to.path == '/') return next()

  // // 如果要访问登录   next() 表示放过他，让他去访问

  // if (!tokenStr) return next('/view/Login') // 如果没有token值  就不允许去其他页面
  // next() // 如果有，就继续放行
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js